module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAASlJREFUKBWtUTFOw0AQ3DtDhKy0dPlARJkiFZJpbUuk4Q008APoeAINvwDJdgsiDSlconwgBRKULsCOb9k5c8YYi4qVVjs3M7e3uiXqxfYxWCB7NKkuwc/BuHw1a3CjfT1VBw+F07UDqNWbuSLiCbLB32rbsVwezaiuV0zsQVakavK8+ejwPsfZdmQ+8chsb5wJgsXgoDljtXw5Z6YZiG6AgwZO8VMwqd7NWjqMuyaHZYRid09Pd8oPcy0PDZpgRoPG467+V1VJktwy8/FfDZVSd1riTEztBgYuFPDoMAw3cuNywGApaNaDkzztpWm6kvrjL8WUR1E0l1rbzQCI/1QS1YXlvrRmhVDiOM5lFvnTJoDBtWcHUH3fv5AOmHkD3NV+4SzLFsi+8AnlLna8ndib0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_sort_up.png
// module id = 862
// module chunks = 121